import React, {useEffect, useState} from 'react'
import { connect } from 'react-redux'
import {bindActionCreators} from "redux";
import {setUserData, setUserToCart} from '../actions/nUserActions'
import {validateMinLength, validateEmail} from '../utils/validators'
import formattedPrice from '../utils/formattedPrice'


const NUser  = (props) => {

  const {user_is_auth, user_fio, user_email, user_phone,
      user_discount, user_confirm_rules, user_comment, cart_total, cart_subtotal,
      cart_extra_rows,
      setUserData, setUserToCart, sendOrder} = props;

  const not_loaded = (props.cart_items.length === 0 && props.cart_num_items > 0) ? true : false;
  const has_items = props.cart_items.length > 0;
  //const [fio, setFio] = useState(user_fio);
  const [fioError, setFioError] = useState("");
  //const [email, setEmail] = useState(user_email);
  const [emailError, setEmailError] = useState("");
  //const [phone, setPhone] = useState(user_phone);
  const [phoneError, setPhoneError] = useState("");
  const [discountChanged, setdiscountChanged] = useState(false);
  //const [comment, setComment] = useState(user_comment);

  const is_shipping = (element, index, array) => element.modifier==='shipping';
  const cart_shipping = cart_extra_rows.find(is_shipping); //todo: get from extra cart_extra_rows
  const cart_shipping_value = cart_shipping !== undefined ? cart_shipping.amount : "0.0";

  const discount_reducer = (initial, element) => {
      if(parseFloat(element.amount) < 0){
          initial+=element.amount;
      }
      return initial;
  }
  const total_discount = parseFloat(cart_subtotal) + parseFloat(cart_shipping_value) - parseFloat(cart_total)

  const handleChangInput = (field, value) =>{
      let field_data = Object();
      field_data[field] = value;

      if ((field==="discount")&&(user_discount!==value)){
          setdiscountChanged(true);
      }
      setUserData(field_data);
    };

  const handleSetValue = (type, value) => {

      switch (type) {
          case "fio":
              setFioError(validateMinLength(value, 6));
              break;

          case "email":
              setEmailError(validateEmail(value));
              break;

          case "phone":
              setPhoneError(validateMinLength(value, 6));
              break;

          case "discount":
              if (discountChanged){
                  setdiscountChanged(false);
                  setUserToCart();
              }
              break;

          default:
             return true
      }

  };

  const handleSendCart = e =>{

      sendOrder();

  }

  return (
    <div className={`cart-profile${not_loaded ? ' blur': '' }`} >
        <div className="ncard">
          <div className="nheader"><h2>Контактная информация</h2></div>
          <div className="nbody">
              <div className="input-group">
                    <span className="input-group-addon">
                        <i className="material-icons">person</i>
                    </span>
                  <div className="form-line">
                      <input type="text"
                             className="form-control"
                             placeholder="ФИО"
                             maxLength="250"
                             value={user_fio}
                             onChange={ e => handleChangInput("fio", e.currentTarget.value)}
                             onBlur={e => handleSetValue("fio", e.currentTarget.value)}
                             onKeyDown={e => e.key === 'Enter' && handleSetValue("fio", e.currentTarget.value)}
                      />

                  </div>
                   {fioError && <span className="text-danger small form-error">{fioError}</span> }
              </div>
              <div className="input-group">
                  <span className="input-group-addon">
                      <i className="material-icons">alternate_email</i>
                  </span>
                  <div className="form-line">
                      <input type="email"
                             className="form-control"
                             placeholder="e-mail"
                             maxLength="75"
                             value={user_email}
                             onChange={ e => handleChangInput("email", e.currentTarget.value)}
                             onBlur={e => handleSetValue("email", e.currentTarget.value)}
                             onKeyDown={e => e.key === 'Enter' && handleSetValue("email",e.currentTarget.value)}
                      />
                  </div>
                  {emailError && <span className="text-danger small form-error">{emailError}</span> }
              </div>
              <div className="input-group">
                  <span className="input-group-addon">
                        <i className="material-icons">phone</i>
                    </span>
                  <div className="form-line">
                      <input type="text"
                             className="form-control"
                             placeholder="телефон"
                             maxLength="20"
                             value={user_phone}
                             onChange={ e => handleChangInput("phone", e.currentTarget.value)}
                             onBlur={e => handleSetValue("phone",e.currentTarget.value)}
                             onKeyDown={e => e.key === 'Enter' && handleSetValue("phone",e.currentTarget.value)}
                      />
                  </div>
                  {phoneError && <span className="text-danger small form-error">{phoneError}</span> }

              </div>
              <div className="input-group">
                  <span className="input-group-addon">
                        <i className="material-icons">credit_card</i>
                    </span>
                  <div className="form-line">
                      <input type="text"
                             className="form-control"
                             placeholder="Номер дисконтной карты"
                             maxLength="10"
                             value={user_discount}
                             onChange={ e => handleChangInput("discount", e.currentTarget.value)}
                             onBlur={e => handleSetValue("discount",e.currentTarget.value)}
                             onKeyDown={e => e.key === 'Enter' && handleSetValue("discount",e.currentTarget.value)}
                      />
                  </div>
              </div>
              { !user_is_auth &&
                  <>
                    <div className="ncart-agry-button">
                        <input type="checkbox"
                               id="ncart-agry"
                               className="ncart-checkbox filled-in"
                               checked={user_confirm_rules}
                               onChange={e => handleChangInput("confirm_rules", e.currentTarget.checked)}
                        />
                            <label htmlFor="ncart-agry">Я прочел и принимаю
                                <a href="/publick/"> условия публичной оферты</a>
                            </label>
                        </div>
                      <p className="text-center">
                          <a href="/accounts/login/" className="ncart-registration">Вход</a>
                          <a href="/accounts/register/" className="ncart-registration">Регистрация</a>
                      </p>
                  </>
              }
          </div>
          { has_items && <div className="nheader"><h2>Сумма заказа</h2></div> }
          { has_items &&
           <div className="nbody">
              <p>
                  <span className="ncart-title">Стоимость</span>
                  <span className="ncart-result">{formattedPrice(cart_subtotal)}&nbsp;₽</span>
              </p>
              { cart_shipping!== undefined && cart_shipping.amount > 0 &&
              <p>
                  <span className="ncart-title">Доставка</span>
                  <span className="ncart-result">{formattedPrice(cart_shipping.amount)}&nbsp;₽</span>
              </p>
              }
              { total_discount > 0 &&
              <p>
                  <span className="ncart-title discount">Скидка</span>
                  <span className="ncart-result discount">{formattedPrice(total_discount)}&nbsp;₽</span>
              </p>
              }
              <hr/>
              <p className="ncart-total">
                  <span className="ncart-title">К оплате</span>
                  <span className="ncart-result">{formattedPrice(cart_total)}&nbsp;₽</span>
              </p>

               <div className="form-line comment">
                      <textarea type="text"
                             id="user-comment"
                             className="form-control"
                             placeholder="Пожелания к заказу"
                             value={user_comment}
                             onChange={ e => handleChangInput("comment", e.currentTarget.value)}
                      />
               </div>

              <button type="button"
                      className="btn btn-block ncart-order-btn"
                      onClick={ e => handleSendCart(e)}>ОФОРМИТЬ ЗАКАЗ</button>
          </div>
          }
      </div>
        <div className="ncart-affix"></div>
    </div>
)}

const mapStateToProps = state => ({
    cart_status: state.ncart.status,
    cart_items: state.ncart.items,
    cart_num_items: state.ncart.num_items,
    cart_total: state.ncart.total,
    cart_subtotal: state.ncart.subtotal,
    cart_extra_rows: state.ncart.extra_rows,
    user_is_auth: state.nuser.is_auth,
    user_fio: state.nuser.fio,
    user_email: state.nuser.email,
    user_phone: state.nuser.phone,
    user_discount: state.nuser.discount,
    user_adress: state.nuser.adress,
    user_confirm_rules: state.nuser.confirm_rules,
    user_comment: state.nuser.comment,
})

const mapDispatchToProps = dispatch => bindActionCreators({setUserData, setUserToCart}, dispatch);

export default connect(
  mapStateToProps,
    mapDispatchToProps
)(NUser)
